import axios from 'axios'
import '@/api'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
    sendSupportRequestEmail: {
        url: '/support',
    }
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_SEND_SUPPORT_REQUEST_EMAIL = 'REQUEST_SEND_SUPPORT_REQUEST_EMAIL'
const RECEIVE_SEND_SUPPORT_REQUEST_EMAIL = 'RECEIVE_SEND_SUPPORT_REQUEST_EMAIL'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
    async sendSupportRequestEmail({ dispatch, commit }, { data }) {
        dispatch('wait/start', 'sending support request email', { root: true })
        commit(REQUEST_SEND_SUPPORT_REQUEST_EMAIL)
        return axios.post(`${endpointConfig.sendSupportRequestEmail.url}`, data)
            .then((response) => {
                commit(RECEIVE_SEND_SUPPORT_REQUEST_EMAIL)
                return Promise.resolve(true)
            })
            .catch((error) => {
                dispatch('wait/end', 'sending support request email', { root: true })
                return Promise.reject(error)
            })
    }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
    [REQUEST_SEND_SUPPORT_REQUEST_EMAIL]() {
    },
    [RECEIVE_SEND_SUPPORT_REQUEST_EMAIL]() {
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
